import React from 'react'
import styled from 'styled-components'
import { IconDotsHorizontal } from '@loadsmart/icons'
import { UnstyledButton } from 'components/Button'

const IconDotsVertical = styled(IconDotsHorizontal)`
  transform: rotate(90deg);
`

export const MenuButton = styled(UnstyledButton)`
  font-size: 13px;
  font-weight: 600;
  line-height: 17px;
  text-align: left;
  width: 100%;
  padding: 7px;

  :hover {
    background: ${({ theme }) => theme.colors.backgroundHover};
  }
`
const Menu = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.borderMenu};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
  padding: 5px 0;
  position: absolute;
  width: 177px;
`
const MenuWrapper = styled.div`
  position: relative;
`

interface Props {
  isOpen: boolean
  onToggle: () => void
  children: false | React.ReactElement
}

export default function DropDownMenu({ isOpen, onToggle, children }: Props) {
  if (!children) return <></>

  return (
    <MenuWrapper>
      <UnstyledButton onClick={onToggle}>
        <IconDotsVertical width={14} />
      </UnstyledButton>
      {isOpen && <Menu>{children}</Menu>}
    </MenuWrapper>
  )
}
